import {
  SkillsErroredAction,
  SkillsLoadedAction,
  KnowledgeConfigInitialized,
  RemoveSkillsErrorAction,
  DeleteSkillSuccessAction,
  SkillsUsageLoadedAction,
  LoadSkillsUsageAction,
  SkillsLoadedAsOrgUserAction,
  LoadSkillsAsOrgUserAction,
  LoadSkillAction,
  LoadSkillSucceededAction,
  LoadSkillErroredAction,
} from './skills.action';
import { SkillApiError } from './skills.errors';
import { createReducer, on } from '@ngrx/store';
import { Skill } from './models/skills.model';
import { SkillsUsage } from './models/skills-usage.model';

export interface SkillsState {
  skills: Skill[];
  skillsUsage: SkillsUsage[];
  skillsAsOrgUser: Skill[];
  apiError: SkillApiError;
  isLoadingSkills: boolean;
}

export const initialState: SkillsState = {
  skills: [],
  skillsUsage: [],
  skillsAsOrgUser: [],
  apiError: null,
  isLoadingSkills: false,
};

export const skillsReducer = createReducer<SkillsState>(
  initialState,
  on(KnowledgeConfigInitialized, (state) => ({
    ...state,
    skills: [],
    skillsAsOrgUser: [],
    skillsUsage: [],
    apiError: null,
  })),
  on(SkillsLoadedAction, (state, { skills }) => ({
    ...state,
    apiError: null,
    skills,
  })),
  on(LoadSkillsAsOrgUserAction, (state) => ({
    ...state,
    skills: [],
    skillsAsOrgUser: [],
    skillsUsage: [],
    isLoadingSkills: true,
    apiError: null,
  })),
  on(SkillsLoadedAsOrgUserAction, (state, { skills }) => ({
    ...state,
    apiError: null,
    isLoadingSkills: false,
    skillsAsOrgUser: skills,
  })),
  on(LoadSkillsUsageAction, (state) => ({
    ...state,
    skillsUsage: [],
    apiError: null,
  })),
  on(SkillsUsageLoadedAction, (state, { skillsUsage }) => ({
    ...state,
    apiError: null,
    skillsUsage,
  })),
  on(SkillsErroredAction, (state, { error }) => ({
    ...state,
    apiError: error,
  })),
  on(RemoveSkillsErrorAction, (state) => ({ ...state, apiError: null })),
  on(DeleteSkillSuccessAction, (state, { id }) => ({
    ...state,
    skillsAsOrgUser: state.skillsAsOrgUser.filter((it) => it.id != id),
    apiError: null,
  })),
  on(LoadSkillAction, (state) => ({
    ...state,
    isLoadingSkills: true,
  })),
  on(LoadSkillSucceededAction, (state, { skill }) => ({
    ...state,
    isLoadingSkills: false,
    // replace skill with same id if already present in array,
    // by first filtering out any existing skills with the same id
    skillsAsOrgUser: [...state.skillsAsOrgUser.filter((s) => s.id !== skill.id), skill],
  })),
  on(LoadSkillErroredAction, (state, { error }) => ({
    ...state,
    isLoadingSkills: false,
    apiError: error,
  })),
);
